import { AlienPatron, Response } from "../objects/AlienPatron";
import { Utils } from '../objects/Utils';
import { ResultsScene } from "./ResultsScene";
import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";
import { PhaserButton } from "src/games/shared/Button";
import TranslateApi from "src/utils/TranslateHelper";
import { GameState } from "../objects/GameState";
import bindAllOfThis from "src/utils/BindThisHelper";
import initializeInteractiveCursor from "src/games/shared/InteractiveCursorUtil";
import { Color } from "src/games/shared/ColorValue";
import AudioTranslations from "src/constants/AudioTranslations";
import { numKeys } from "src/constants/KeyboardNumKeys";
export class AnswerPatronQuestionScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;
    stars: TiledGameObject;
    buttonYCoordinate: number;

    constructor() {
        super({
            key: "AnswerPatronQuestionScene" + Math.random(),
        });
    }

    preload(): void {
        this.load.image("pixel", require("/src/assets/qci/sprites/pixel.png"));
        this.load.tilemapTiledJSON("map", require("/src/assets/qci/maps/hotel_aurora_1.json"));
        this.load.image('lobby', require("/src/assets/qci/backgrounds/hotel_lobby.jpg"));
        this.load.image('desk', require("/src/assets/qci/backgrounds/hotel_desk.png"));
        this.load.image('star', require("/src/assets/qci/sprites/star.png"));

        // Alien Patrons
        this.load.image('alien_1', require("/src/assets/qci/sprites/aliens/sleb-normal.png"));
        this.load.image('alien_2', require("/src/assets/qci/sprites/aliens/snib-normal.png"));
        this.load.image('alien_3', require("/src/assets/qci/sprites/aliens/squeelo-normal.png"));

        var keys = [
            "HotelAurora.Phaser.alienIntro1", "HotelAurora.Phaser.alienIntro2", "HotelAurora.Phaser.alienIntro3",
            "HotelAurora.Phaser.AlienStudentInteractions.1.alienQuestion", "HotelAurora.Phaser.AlienStudentInteractions.1.responses.1", "HotelAurora.Phaser.AlienStudentInteractions.1.responses.2", "HotelAurora.Phaser.AlienStudentInteractions.1.responses.3",
            "HotelAurora.Phaser.AlienStudentInteractions.2.alienQuestion", "HotelAurora.Phaser.AlienStudentInteractions.2.responses.1", "HotelAurora.Phaser.AlienStudentInteractions.2.responses.2", "HotelAurora.Phaser.AlienStudentInteractions.2.responses.3",
            "HotelAurora.Phaser.AlienStudentInteractions.3.alienQuestion", "HotelAurora.Phaser.AlienStudentInteractions.3.responses.1", "HotelAurora.Phaser.AlienStudentInteractions.3.responses.2", "HotelAurora.Phaser.AlienStudentInteractions.3.responses.3",
            "HotelAurora.Phaser.AlienStudentInteractions.4.alienQuestion", "HotelAurora.Phaser.AlienStudentInteractions.4.responses.1", "HotelAurora.Phaser.AlienStudentInteractions.4.responses.2", "HotelAurora.Phaser.AlienStudentInteractions.4.responses.3",
            "HotelAurora.Phaser.AlienStudentInteractions.5.alienQuestion", "HotelAurora.Phaser.AlienStudentInteractions.5.responses.1", "HotelAurora.Phaser.AlienStudentInteractions.5.responses.2", "HotelAurora.Phaser.AlienStudentInteractions.5.responses.3",
            "HotelAurora.Phaser.AlienStudentInteractions.6.alienQuestion", "HotelAurora.Phaser.AlienStudentInteractions.6.responses.1", "HotelAurora.Phaser.AlienStudentInteractions.6.responses.2", "HotelAurora.Phaser.AlienStudentInteractions.6.responses.3",
        ];

        keys.forEach((key) => {
            this.load.audio(key, AudioTranslations.FindByKeyAndLanguage(key, TranslateApi.currentLanguage.code).url);
        });
    }

    create(): void {
        bindAllOfThis(this, AnswerPatronQuestionScene.prototype);
        this.initialize();
        this.generateScene();
        initializeInteractiveCursor(this);
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'map' });
    }

    generateScene() {
        this.background = this.add.image(0, 0, "lobby");
        this.background.setOrigin(0);
        this.background.setDepth(0);
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.answerPatronQuestion();
    }

    /**
     * Scene: AlienPatron is asking student a question, the student has three buttons to choose from to answer positively/negatively
     */
    answerPatronQuestion(): void {
        var patronText;
        var i = 0;
        var responses = [];
        var audio1, audio2;
        var patron = AlienPatron.ALL_PATRONS[GameState.current.alienIndex];
        if (GameState.current.dialogIndex < patron.dialog.interactions.length) {
            var interaction = patron.dialog.interactions[GameState.current.dialogIndex];

            this.map.getObjectLayer("Patron Layer").objects.forEach((ob: TiledGameObject) => {
                if (ob.name === "patron") {
                    var patronImage = Utils.createPatronImage(this, ob, patron.assetKey);
                    patron.object = patronImage;
                    var deskLayer = this.add.image(0, 0, "desk");
                    deskLayer.setOrigin(0);
                    deskLayer.setDisplaySize(this.gameWidth, this.gameHeight);
                }
                else if (ob.name === "dialog") {
                    var translatedText = TranslateApi.translate(interaction.alienQuestion);
                    // If it's the first interaction, add the patron's name
                    if (GameState.current.dialogIndex === 0) {
                        translatedText = TranslateApi.translate("HotelAurora.Phaser.alienIntro" + patron.id) + " " + translatedText;
                        audio1 = this.sound.add("HotelAurora.Phaser.alienIntro" + patron.id);
                        audio1.play();
                    }

                    audio2 = this.sound.add(interaction.alienQuestion);
                    audio2.play("", {
                        delay: audio1 != null ? audio1.totalDuration : 0.5,
                    });

                    patronText = Utils.createDialog(this, ob, translatedText);
                }
                else if (ob.name.startsWith("button")) {
                    var responseObj = interaction.responses[i];
                    responses.push(interaction.responses[i].text);
                    this.createResponseButton(ob, responseObj, i);
                    i++;
                }
                else if (ob.name === "score") {
                    this.stars = ob;
                    this.showScore();
                }
            });

        }
        else {
            this.sound.stopAll();
            // Dialog is over, patron decides if they want to stay or not
            this.scene.add("ResultsScene", ResultsScene, true);
            return;
        }

        var delay = audio1 != null ? audio1.totalDuration + audio2.totalDuration : audio2.totalDuration + 1.2;
        responses.forEach((r) => {
            var audioResponse = this.sound.add(r);
            audioResponse.play("", {
                delay: delay
            });
            delay += audioResponse.totalDuration + 1;
        });
    }

    createResponseButton(ob: TiledGameObject, response: Response, index: number): void {
        if (ob.name === "button_1") {
            this.buttonYCoordinate = ob.y;
        }

        var config = Utils.getButtonConfig();
        config.backgroundColor = Color.KUDER_SECONDARY_BUTTON;
        config.smartHeight = true;
        var translatedText = (index + 1) + ': ' + TranslateApi.translate(response.text);
        var button = new PhaserButton(this, ob.x, ob.y, ob.width, ob.height, translatedText, config);
        button.setDisplaySize(button.width, button.getIdealButtonHeight());
        if (ob.name !== "button_1") {
            button.setY(this.buttonYCoordinate);
        }
        this.buttonYCoordinate += button.displayHeight + 30;
        button.name = name;
        button.on('buttonClicked', () => {
            this.calculateResponseChoice(response.points);
        });

        let numKey = numKeys[index];
        this.onKeydown(() => { this.calculateResponseChoice(response.points); }, numKey.keyCode, numKey.altKeyCode);
    }

    calculateResponseChoice(points : number): void {
        this.sound.stopAll();
        GameState.current.dialogIndex += 1;
        GameState.current.score += points;
        // Don't allow score to be negative
        GameState.current.score = Math.max(0, GameState.current.score);
        this.scene.remove(this);
        this.scene.add("AnswerPatronQuestionScene", AnswerPatronQuestionScene, true);
    }

    /**
     * Show score as stars in top right corner
     */
    showScore(): void {
        var score = this.add.group();
        for (var i = 0; i < GameState.current.score; i++) {
            var star = this.add.image(0, 0, "star");
            star.setOrigin(0);
            star.setDisplaySize(20, 20);
            star.setTint(0xf4dc42);
            score.add(star);
        }

        Phaser.Actions.GridAlign(score.getChildren(), {
            x: this.stars.x,
            y: this.stars.y,
            width: GameState.current.score,
            height: 1,
            cellHeight: 30,
            cellWidth: 30,
        });
    }

    onKeydown(event: Function, ...keys: string[]): void {
        keys.forEach((key: string) => {
            this.input.keyboard.on('keydown_' + key, event);
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/HotelAuroraGame/scenes/AnswerPatronQuestionScene.ts